module.exports = __webpack_public_path__ + "static/media/DefaultUser.22d57ae2.png";